<app-ai-modals-template [templateConfig]="templateConfig()" />
